window.customElements.define(
  'custom-announcement-bar',
  class CustomAnnouncementBar extends window.HTMLElement {
    connectedCallback() {
      this.timerEnabled = this.dataset.timerEnabled === 'true';

      if (!this.timerEnabled) return;

      this.initTimer();
    }

    disconnectedCallback() {
      this.stopTimer();
    }

    // Initialize timer
    initTimer() {
      const endDate = this.dataset.endDate; // DD/MM/YYYY
      const endHour = parseInt(this.dataset.endHour || 23, 10);

      // Validate date format
      if (!endDate || !endDate.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        console.error('Invalid date format. Expected DD/MM/YYYY');
        return;
      }

      // Parse DD/MM/YYYY format
      const [day, month, year] = endDate.split('/').map(Number);
      this.endTime = new Date(year, month - 1, day, endHour, 0, 0);

      // Check if end date is in future
      if (this.endTime <= new Date()) {
        this.hideBar();
        return;
      }

      this.timerElements = {
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]'),
      };

      // Check if timer elements exist
      if (!this.timerElements.hours || !this.timerElements.minutes || !this.timerElements.seconds) {
        console.error('Timer elements not found');
        return;
      }

      this.updateTimer();
      this.intervalId = setInterval(() => this.updateTimer(), 1000);
    }

    // Update timer display
    updateTimer() {
      const now = new Date();
      const diff = this.endTime - now;

      if (diff <= 0) {
        this.stopTimer();
        this.hideBar();
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      this.timerElements.hours.textContent = String(hours).padStart(2, '0');
      this.timerElements.minutes.textContent = String(minutes).padStart(2, '0');
      this.timerElements.seconds.textContent = String(seconds).padStart(2, '0');
    }

    // Stop timer interval
    stopTimer() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    // Hide announcement bar
    hideBar() {
      this.style.display = 'none';
    }
  }
);
